var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGeschlosseneAnfragen = function SvgIconGeschlosseneAnfragen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "702-a",
    x1: 0.512,
    y1: 1.084,
    x2: 0.492,
    y2: 0.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c52cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a1343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "702-c",
    x1: 0.511,
    y1: 1.03,
    x2: 0.501,
    y2: 0.269,
    xlinkHref: "#702-a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "702-d",
    x1: 0,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#702-a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "702-e",
    x1: 0.501,
    y1: 1.099,
    x2: 0.491,
    y2: 0.098,
    xlinkHref: "#702-a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "702-b",
    x: 47,
    y: 30.08,
    width: 105.486,
    height: 105.009,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#702-b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.486 43.963 64.8.1H22.608L0 43.963l2.866 12.259h4.458l5.413 27.145a2.47 2.47 0 0 0 .716 1.433 4.873 4.873 0 0 0 1.353 1.194 7.507 7.507 0 0 0 1.831.8 8.718 8.718 0 0 0 2.149.318H68.62a6.7 6.7 0 0 0 2.149-.318 7.507 7.507 0 0 0 1.831-.8 3.962 3.962 0 0 0 1.353-1.194 3.044 3.044 0 0 0 .716-1.433l5.413-27.145h4.458Z",
    transform: "translate(56 35.98)",
    style: {
      fill: "url(#702-a)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 60.1a6.6 6.6 0 0 1 2.547.478 7.751 7.751 0 0 1 1.911 1.194 5.06 5.06 0 0 1 1.114 1.751 3.886 3.886 0 0 1 .08 2.149l-5.97 29.852a2.47 2.47 0 0 1-.716 1.433 4.874 4.874 0 0 1-1.353 1.194 7.508 7.508 0 0 1-1.831.8 8.719 8.719 0 0 1-2.149.318H20.519a6.7 6.7 0 0 1-2.149-.318 7.508 7.508 0 0 1-1.831-.8 3.963 3.963 0 0 1-1.353-1.194 3.044 3.044 0 0 1-.716-1.433L8.578 65.672a4.906 4.906 0 0 1 .08-2.149 4.122 4.122 0 0 1 1.114-1.751 4.617 4.617 0 0 1 1.911-1.194 6.323 6.323 0 0 1 2.547-.478Z",
    transform: "translate(54.268 23.743)",
    style: {
      fill: "url(#702-c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8 51.471a2.355 2.355 0 0 1 .8.159 1.131 1.131 0 0 1 .478.159c.08 0 .159.08.318.08l.478.239a.278.278 0 0 1 .159.08 2.793 2.793 0 0 1 .637.4l.08.08a.959.959 0 0 1 .4.4l.478.478c.159.159.239.4.4.557l-19.5-35.265v-.239a4698.487 4698.487 0 0 0-.239-.239l-.08-.08c-.08-.08-.159-.159-.239-.159l-.08-.08a1.1 1.1 0 0 0-.318-.239.078.078 0 0 1-.08-.08c-.08-.08-.159-.08-.239-.159-.08 0-.08 0-.159-.08-.08 0-.159-.08-.239-.08h-32.4l-.08.08-.08.08a.078.078 0 0 0-.08.08l-.08.08a.078.078 0 0 1-.08.08l-.08.08-.08.08c0 .08-.08.08-.08.159s-.08.08-.08.159L9.1 54.1a2.419 2.419 0 0 1 .4-.557v-.08c.159-.159.239-.318.4-.478a3.462 3.462 0 0 1 .557-.478 4.444 4.444 0 0 1 .637-.4c.239-.08.478-.239.716-.318.239-.08.478-.159.8-.239.239-.08.557-.08.8-.159.318 0 .557-.08.876-.08h62.638a3.386 3.386 0 0 0 .876.159Z",
    transform: "translate(54.144 32.451)",
    style: {
      fill: "#3c2e73"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2 68.58a4.309 4.309 0 0 1 1.513.239 4.219 4.219 0 0 1 1.194.637 3.005 3.005 0 0 1 .8.955 2.087 2.087 0 0 1 .159 1.194 3.521 3.521 0 0 1-.4 1.194 5.4 5.4 0 0 1-.955.955 6.346 6.346 0 0 1-1.274.637 5 5 0 0 1-1.513.239H35.511A4.635 4.635 0 0 1 34 74.391a3.668 3.668 0 0 1-1.353-.716 2.744 2.744 0 0 1-.955-.955 1.955 1.955 0 0 1-.4-1.194 2.087 2.087 0 0 1 .159-1.194 1.859 1.859 0 0 1 .8-.955 2.871 2.871 0 0 1 1.194-.637 4.635 4.635 0 0 1 1.513-.239H65.2Z",
    transform: "translate(49.624 22.03)",
    style: {
      fill: "#201563"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.486 55.1-2.865 12.259H2.866L0 55.1Z",
    transform: "translate(56 24.763)",
    style: {
      fill: "url(#702-d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 43.863 22.688 0H64.8l22.686 43.863Z",
    style: {
      fill: "url(#702-e)"
    },
    transform: "translate(56 36)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(111 14.537)",
    style: {
      fill: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.062 19.599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 30.635 9.987 9.987L45.21 20l-5.271 5.271",
    transform: "translate(-2.486 -2.892)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.465,
    cy: 27.465,
    r: 27.465,
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h200v160H0z"
  }));
};
export default SvgIconGeschlosseneAnfragen;